<template>
  <div>

    <div id="compare" class="bg-image small"></div>

    <div class="bg-white">
      <div class="container py-3">
        <br class="d-none d-md-block">
        <h1 class="h2 text-md-center">Rental vs. buying?</h1>
        <p class="lead grey text-md-center mb-md-5">Compare the difference between renting and buying trailer assets.</p>


<div class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th class="h4 pl-2 w-50" style="min-width:250px">Rental</th>
        <th class="h4 pl-2 w-50" style="min-width:250px">Buying</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="align-middle text-center py-5 px-2 px-md-4 px-lg-5">
          <i class="fal fa-3x fa-hand-holding-usd grey"></i>
          <span class="lead d-block grey mt-1">Expenses</span>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Fixed monthly fee, all included - no upfront payment</li>
            <li><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Better prices due to larger volume</li>
          </ul>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Costly and time-consuming process to get bank pre-credit approval</li>
            <li><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Unpredictable costs</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td class="align-middle text-center py-5 px-2 px-md-4 px-lg-5">
          <i class="fal fa-3x fa-clock grey"></i>
          <span class="lead d-block grey mt-1">Period</span>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Flexible contract period</li>
            <li><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Possible to adjust during the period</li>
          </ul>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Locked by ownership</li><br class="d-xl-none">
            <li><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Dependent on bank loan terms</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td class="align-middle text-center py-5 px-2 px-md-4 px-lg-5">
          <i class="fal fa-3x fa-truck-moving grey"></i>
          <span class="lead d-block grey mt-1">Fleet</span>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Asset light and hassle-free - focus on core business</li>
            <li><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Short lead time and newest material</li>
          </ul>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Fleet management takes resources away from core business</li>
            <li><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Risk related to resale of used material</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td class="align-middle text-center py-5 px-2 px-md-4 px-lg-5">
          <i class="fal fa-3x fa-tools grey"></i>
          <span class="lead d-block grey mt-1">Maintenance</span>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Local workshops for service - 24/7 breakdown service</li>
            <li><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Maintenance expenses included in fee</li>
          </ul>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Negotiation with local workshops</li>
            <li><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Separate agreements with workshops and breakdown services</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td class="align-middle text-center py-5 px-2 px-md-4 px-lg-5">
          <i class="fal fa-3x fa-id-card-alt grey"></i>
          <span class="lead d-block grey mt-1">Contact</span>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>One dedicated contact the entire period</li>
            <li><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>No manufacturer preferences - updated on trends across the industry</li>
          </ul>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Knowledge field based on own offerings</li>
            <li><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Has own agenda - pushes certain products</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td class="align-middle text-center py-5 px-2 px-md-4 px-lg-5">
          <i class="fal fa-3x fa-chart-line-down grey"></i>
          <span class="lead d-block grey mt-1">Economic trend</span>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Easy to trade-in when demand is changing</li>
            <li><span class="fa-li"><i class="far fa-lg fa-check-circle green mr-1 mt-1"></i></span>Agile set-up - maximise profit and minimise loss</li>
          </ul>
        </td>
        <td class="align-middle">
          <ul class="fa-ul ml-4 mb-0">
            <li class="mb-3"><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>Complex and expensive to adjust fleet according to demand</li>
            <li><span class="fa-li"><i class="far fa-lg fa-exclamation-circle red mr-1 mt-1"></i></span>No flexibility from banks when needed (ex. crisis)</li>
          </ul>
        </td>
      </tr>


    </tbody>
  </table>
</div>

      </div>
    </div>
    
    <pno-prompt />

  </div>
</template>

<script>
import PnoPrompt from '@/components/PnoPrompt.vue'

export default {
    mounted() {
        this.$store.commit('meta/title', 'Rental vs. buying trailers?')
        this.$store.commit('meta/description', 'Compare the difference between renting and buying trailer assets.')
    },
	components: { PnoPrompt }
}
</script>
